import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';

const ImageCarousel = ({ images, alt = 'Collection image' }) => {
  if (!images || images.length === 0) {
    return (
      <div className="aspect-video bg-gray-100 rounded-lg flex items-center justify-center">
        <p className="text-gray-400">No images available</p>
      </div>
    );
  }

  return (
    <Carousel className="w-full" data-testid="image-carousel">
      <CarouselContent>
        {images.map((image, index) => (
          <CarouselItem key={index}>
            <div className="aspect-video overflow-hidden rounded-lg bg-gray-100">
              <img
                src={image}
                alt={`${alt} ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                data-testid={`carousel-image-${index}`}
              />
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      {images.length > 1 && (
        <>
          <CarouselPrevious
            className="left-2 bg-white/90 hover:bg-white"
            data-testid="carousel-prev"
          />
          <CarouselNext
            className="right-2 bg-white/90 hover:bg-white"
            data-testid="carousel-next"
          />
        </>
      )}
      {/* Image indicators */}
      {images.length > 1 && (
        <div className="flex justify-center gap-2 mt-4" data-testid="carousel-indicators">
          {images.map((_, index) => (
            <div
              key={index}
              className="w-2 h-2 rounded-full bg-gray-300"
            />
          ))}
        </div>
      )}
    </Carousel>
  );
};

export default ImageCarousel;
